import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { formatApiErrorDetail } from "@/lib/api";
import { NativeSelect } from "@/components/crm/common";
import { LineItems, inputCls } from "./LineItems";

function Field({ f, value, set }) {
  if (f.type === "select") return <NativeSelect testid={`doc-${f.name}`} className="w-full" value={value ?? ""} onChange={set} placeholder={f.placeholder ?? "Select…"} options={f.options} />;
  if (f.type === "textarea") return <textarea data-testid={`doc-${f.name}`} rows={3} value={value ?? ""} onChange={(e) => set(e.target.value)} className={`${inputCls} h-auto py-2`} />;
  return <input data-testid={`doc-${f.name}`} type={f.type || "text"} value={value ?? ""} onChange={(e) => set(e.target.value)} className={inputCls} />;
}

export function DocDialog({ open, onOpenChange, title, fields, initial, items, discount, onSubmit, submitLabel = "Save", testid = "doc-form" }) {
  const [f, setF] = useState({});
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) setF({ items: [{ description: "", qty: 1, rate: 0 }], gst_rate: 18, ...(initial || {}) }); }, [open, initial]);
  const shown = fields.filter((x) => !x.when || x.when(f));
  const showItems = items && (typeof items !== "function" || items(f));
  const save = async () => {
    setBusy(true);
    try { await onSubmit(f); onOpenChange(false); } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    setBusy(false);
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid={testid} className="max-h-[90vh] overflow-y-auto sm:max-w-2xl">
        <DialogHeader><DialogTitle>{title}</DialogTitle></DialogHeader>
        <div className="grid gap-3 sm:grid-cols-2">
          {shown.map((x) => (
            <label key={x.name} className={`space-y-1.5 text-xs font-semibold text-zinc-600 ${x.full || x.type === "textarea" ? "sm:col-span-2" : ""}`}>
              <span>{x.label}{x.required && " *"}</span><Field f={x} value={f[x.name]} set={(v) => setF((s) => ({ ...s, [x.name]: v, ...(x.onSet ? x.onSet(v, s) : {}) }))} />
            </label>
          ))}
        </div>
        {showItems && <LineItems items={f.items || []} onChange={(v) => setF((s) => ({ ...s, items: v }))} gst={f.gst_rate} discount={discount ? f.discount : 0} />}
        <div className="flex justify-end"><Button data-testid={`${testid}-submit`} disabled={busy || shown.some((x) => x.required && !f[x.name])} onClick={save}>{submitLabel}</Button></div>
      </DialogContent>
    </Dialog>
  );
}
